export const MONITOR_EVENT_TYPES = [
  'PROMPT_ADDED',
  'PROMPT_DELETED',
  'MODEL_ADDED',
  'MODEL_DELETED',
  'MODEL_RELEASED',
  'MONITORING_SCHEDULE_CHANGED',
] as const;

export type MonitorEventType = (typeof MONITOR_EVENT_TYPES)[number];

export const isMonitorEventType = (value: string): value is MonitorEventType =>
  MONITOR_EVENT_TYPES.includes(value as MonitorEventType);
